import { Divider, Typography } from '@mui/material';
import { WithTranslation, withTranslation } from 'react-i18next';

import { SCREENS } from '@core/assistant/interfaces';
import { useAssistant } from '@core/assistant/providers/Provider';
import ModalBox from '@core/assistant/ModalBox';
import Form from '@core/assistant/Form';
import ChatBox from '@core/assistant/ChatBox';

import { useStyles } from './styles';

const ChatScreen = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  const { setOpen, setNavigationHistory, navigate, stopPlayback } =
    useAssistant();

  const renderTitle = () => {
    return (
      <Typography sx={classes.title}>
        {translate('assistant.askMe.askMe')}
      </Typography>
    );
  };

  return (
    <ModalBox
      title={renderTitle()}
      onClose={() => {
        stopPlayback();
        setOpen(false);
        setNavigationHistory([]);
        navigate(SCREENS.DEFAULT);
      }}
      onBack={() => {
        navigate(SCREENS.DEFAULT, true);
      }}
    >
      <Typography sx={classes.tabTitle}>
        {translate('assistant.askMe.currentChat')}
      </Typography>
      <ChatBox />
      <Divider sx={classes.divider} />
      <Form />
    </ModalBox>
  );
};

export default withTranslation('common')(ChatScreen);
